import React from "react";
import { Bot, BookOpen } from "lucide-react";

export const PlayerAgents = ({ agents }) => (
  <section className="grid gap-5 lg:grid-cols-3" data-testid="player-step-agents">
    {agents.map((a) => (
      <article key={a.name} className="flex flex-col border border-slate-200 bg-white p-6" data-testid="player-agent-card">
        <div className="flex h-10 w-10 items-center justify-center bg-slate-900 text-accent-blue-light">
          <Bot className="h-4 w-4" />
        </div>
        <p className="mt-4 text-[10px] uppercase tracking-[0.2em] text-accent-blue">{a.department}</p>
        <h3 className="mt-1 font-display text-lg text-slate-900">{a.name}</h3>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">{a.description}</p>
        <p className="mt-4 text-[10px] uppercase tracking-[0.18em] text-slate-500">Iniciadores por actividad</p>
        <ul className="mt-2 space-y-1.5">
          {a.prompts.map((p) => (
            <li key={p.title} className="border-l-2 border-accent-blue/40 pl-2 text-xs text-slate-700">{p.title}</li>
          ))}
        </ul>
        <p className="mt-auto flex items-center gap-1 pt-4 text-[11px] text-slate-500">
          <BookOpen className="h-3 w-3" /> {a.kbl_docs} documentos en su biblioteca
        </p>
      </article>
    ))}
  </section>
);
